import { render, staticRenderFns } from "./FormQuestionCheckboxType.vue?vue&type=template&id=1555527f"
import script from "./FormQuestionCheckboxType.vue?vue&type=script&lang=js"
export * from "./FormQuestionCheckboxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports